import { render, staticRenderFns } from "./CollabLevel.vue?vue&type=template&id=db7b454c"
import script from "./CollabLevel.vue?vue&type=script&lang=js"
export * from "./CollabLevel.vue?vue&type=script&lang=js"
import style0 from "./CollabLevel.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports